import IconStatusBarPending from '~/assets/images/statusBar-pending.svg'

import { isFailed, isInProgress, isSuccess } from '../../helper'
import { TRADE_STATUS } from '../../types'
import {
  useStatusBarAssets,
  type StatusBarAssets,
} from './useStatusBarAssets'
import Lottie from '~/components/Lottie'

interface Props {
  status: TRADE_STATUS
}

const renderLoading = (status: TRADE_STATUS, assets: StatusBarAssets) => {
  const { leftLoading, rightLoading } = assets

  if (isInProgress(status)) {
    const animation = status === TRADE_STATUS.PENDING ? rightLoading : leftLoading
    return (
      <Lottie
        animationData={animation}
        autoPlay
        loop
        style={{ display: 'flex', flex: 1 }}
      />
    )
  }
  return null
}

const renderCompleted = (status: TRADE_STATUS, assets: StatusBarAssets) => {
  const { success, failed } = assets

  if (isInProgress(status)) {
    return null
  }
  if (isFailed(status)) {
    return <img src={failed} />
  }
  const statusImage = isSuccess(status) ? (
    <img src={success} />
  ) : (
    <img src={IconStatusBarPending} />
  )
  return statusImage
}

const StatusBar: React.FC<Props> = ({
  status,
}) => {
  const assets = useStatusBarAssets()
  return (
    <div className="status-bar">
      {renderLoading(status, assets)}
      {renderCompleted(status, assets)}
    </div>
  )
}

export default StatusBar
